import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconTextItalic';
/** Renders an SVG icon. */
const SvgTextItalic = ({
  size,
  'aria-hidden': ariaHidden,
  tone,
  UNSAFE_className,
  UNSAFE_style,
  ...rest
}: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M15 5a1 1 0 0 1 1-1h8a1 1 0 1 1 0 2h-3.236l-7.455 20H16a1 1 0 1 1 0 2H8a1 1 0 1 1 0-2h3.236l7.455-20H16a1 1 0 0 1-1-1"
      />
    </svg>
  );
};
SvgTextItalic.displayName = displayName;
export default SvgTextItalic;
